<div *ngIf="isOpen"
    class="modal-backdrop fixed inset-0 bg-slate-900/50 backdrop-blur-[2px] flex items-center justify-center p-4"
    [style.z-index]="backdropZIndex"
    (click)="$event.stopPropagation()">
    <div class="bg-white rounded shadow-xl w-full max-w-md font-fira-condensed flex flex-col animation-scale-in">

        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-2 border-b border-white/20 bg-primary shrink-0 rounded-t">
            <h3 class="text-sm font-bold text-white tracking-tight flex items-center gap-2">
                <i class="fas fa-trash-alt text-white/80"></i>
                {{ title || 'Delete Confirmation' }}
            </h3>
            <button (click)="onCancel()" [disabled]="isProcessing" class="text-white/80 hover:text-white transition-colors disabled:opacity-50">
                <i class="fas fa-times text-xs"></i>
            </button>
        </div>

        <!-- Content -->
        <div class="bg-slate-100/50 p-6 flex-1 flex flex-col rounded-b">
            <div class="flex items-start gap-4 mb-6">
                <div class="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                    <i class="fas fa-exclamation-triangle text-red-500 text-lg"></i>
                </div>
                <div class="flex-1 pt-1">
                    <p class="text-slate-700 text-sm leading-relaxed font-medium">
                        {{ message || 'Are you sure you want to delete this item?' }}
                    </p>
                    <p class="text-slate-500 text-xs mt-1" *ngIf="!isProcessing">This action cannot be undone.</p>
                    <p class="text-amber-700 text-xs mt-2 font-medium leading-relaxed" *ngIf="isProcessing && processingHint">
                        {{ processingHint }}
                    </p>
                    <p class="text-amber-700 text-xs mt-2 font-medium leading-relaxed" *ngIf="isProcessing && !processingHint">
                        {{ defaultProcessingMessage }}
                    </p>
                </div>
            </div>

            <!-- Footer -->
            <div class="flex items-center justify-end gap-3 mt-auto">
                <app-button variant="secondary" size="sm" (click)="onCancel()" [disabled]="isProcessing">
                    Cancel
                </app-button>
                <app-button variant="secondary" size="sm" class="custom-delete-btn text-danger-btn" (click)="onConfirm()"
                    [disabled]="isProcessing">
                    <i *ngIf="isProcessing" class="fas fa-spinner fa-spin mr-2"></i>
                    {{ isProcessing ? 'Deleting...' : 'Delete' }}
                </app-button>
            </div>
        </div>
    </div>
</div>